import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
//import ReactDOM from 'react-dom'; // react17
import { createRoot } from 'react-dom/client'; // react18
import './index.css';
import { BrowserRouter, withRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import StylesProvider from '@mui/styles/StylesProvider';
import createGenerateClassName from '@mui/styles/createGenerateClassName';
import Error from 'common/components/Error';
import { routes } from 'routes';
import { StyledEngineProvider } from '@mui/material/styles';

import i18n from './i18n';

import { setupSentry } from 'common/utils/sentryBrowser';
import * as Sentry from '@sentry/react';

import logger from 'itrvl-logger';
// Setup logger
logger.setup(false, true);
window.logger = logger;

const generateClassName = createGenerateClassName({
  productionPrefix: 'wc',
});

const fallback = ({ eventId }) => {
  return <Error eventId={eventId} withSentry={process.env.REACT_APP_ENVIRONMENT !== 'production'} />;
};

const SentrySetup = withRouter(({ history, children }) => {
  useEffect(() => {
    setupSentry('client', history, routes);
  }, [history]);

  return children;
});

const BaseApp = () => {
  return (
    <StyledEngineProvider injectFirst>
      <BrowserRouter>
        <SentrySetup>
          <Sentry.ErrorBoundary fallback={fallback}>
            <StylesProvider generateClassName={generateClassName}>
              <App />
            </StylesProvider>
          </Sentry.ErrorBoundary>
        </SentrySetup>
      </BrowserRouter>
    </StyledEngineProvider>
  );
};

if (process.env.REACT_APP_GA4_KEY_CLIENT) {
  ReactGA.initialize(process.env.REACT_APP_GA4_KEY_CLIENT);
  ReactGA.send({ hitType: 'pageview' });
}

(async () => await i18n.init(undefined, window.initialLanguage))();
//ReactDOM.render(<BaseApp />, document.getElementById('root')); // react17
createRoot(document.getElementById('root')).render(<BaseApp />); // react18

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
